<template>
  <div class="user-management">
    <!-- 左侧导航菜单 -->
    <div class="sidebar">
      <el-card class="nav-card" shadow="never">
        <div class="nav-header">
          <h3 class="nav-title">个人中心</h3>
          <p class="nav-subtitle">系统管理</p>
        </div>
        <el-menu 
          default-active="1" 
          class="nav-menu" 
          ref="menu" 
          @select="handleSelect"
        >
          <el-menu-item index="1">
            <i class="el-icon-user"></i>
            <span>账号管理</span>
          </el-menu-item>
          <el-menu-item index="2">
            <i class="el-icon-setting"></i>
            <span>属性管理</span>
          </el-menu-item>
          <el-menu-item index="3">
            <i class="el-icon-folder"></i>
            <span>文件分类</span>
          </el-menu-item>
        </el-menu>
      </el-card>
    </div>
    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 账号管理 -->
      <div v-if="userDataActive === true" class="content-section">
        <el-card class="content-card" shadow="always">
          <div class="card-header">
            <div class="header-info">
              <h2 class="section-title">账号管理</h2>
              <el-tag type="info" size="small" class="count-tag">
                共 {{ userData.length }} 个账号
              </el-tag>
            </div>
            <div class="header-actions">
              <el-button 
                type="warning" 
                icon="el-icon-switch-button"
                @click="logout"
                class="logout-btn"
              >
                退出登录
              </el-button>
            </div>
          </div>

          <el-table 
            :max-height="tableHeight" 
            :data="userData" 
            class="data-table"
            stripe
          >
            <el-table-column
              prop="userName"
              label="账号"
              min-width="30%"
              class-name="username-column"
            >
              <template slot-scope="{ row }">
                <div class="username-cell">
                  <i class="el-icon-user"></i>
                  <span class="username-text">{{ row.userName }}</span>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              prop="type"
              label="账号类型"
              min-width="40%"
              class-name="type-column"
            >
              <template slot-scope="{ row }">
                <el-tag 
                  :type="getAccountTypeTag(row.type)" 
                  size="small"
                  class="type-tag"
                >
                  {{ row.type }}
                </el-tag>
              </template>
            </el-table-column>
            
            <el-table-column 
              label="操作" 
              min-width="30%"
              class-name="action-column"
            >
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="primary"
                  icon="el-icon-edit"
                  @click="beforeUpdatePassword(scope.$index, scope.row)"
                  class="action-btn"
                >
                  修改密码
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>

      <!-- 修改密码对话框 -->
      <el-dialog 
        title="修改密码" 
        :visible.sync="updatePasswordVisible"
        width="500px"
        class="custom-dialog"
      >
        <el-form :model="passwordForm" label-width="100px" class="dialog-form">
          <el-form-item label="账号名字">
            <el-input v-model="selectedUser.userName" disabled />
          </el-form-item>
          <el-form-item label="旧密码">
            <el-input 
              placeholder="请输入旧密码" 
              v-model="oldPassword" 
              show-password 
              clearable 
            />
          </el-form-item>
          <el-form-item label="新密码">
            <el-input 
              placeholder="请输入新密码" 
              v-model="newPassword" 
              show-password 
              clearable 
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="updatePasswordVisible = false">取 消</el-button>
          <el-button type="primary" @click="updatePassword">确 定</el-button>
        </div>
      </el-dialog>
      </el-col>

      <!-- 属性管理 -->
      <div v-if="propertyDataActive === true" class="content-section">
        <el-card class="content-card" shadow="always">
          <div class="card-header">
            <div class="header-info">
              <h2 class="section-title">属性管理</h2>
              <el-tag type="info" size="small" class="count-tag">
                共 {{ propertyData.length }} 个属性
              </el-tag>
            </div>
            <div class="header-actions">
              <el-button 
                type="primary" 
                icon="el-icon-plus"
                @click="newPropertyVisible = true"
                class="add-btn"
              >
                新建属性
              </el-button>
            </div>
          </div>

          <el-table 
            :max-height="tableHeight" 
            :data="propertyData.filter(data => !tableSearch || data.label.toLowerCase().includes(tableSearch.toLowerCase()))"
            class="data-table"
            stripe
          >
            <el-table-column
              prop="label"
              label="属性名称"
              min-width="60%"
              class-name="property-column"
            >
              <template slot-scope="{ row }">
                <div class="property-cell">
                  <i class="el-icon-tag"></i>
                  <span class="property-text">{{ row.label }}</span>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column 
              label="操作" 
              min-width="40%"
              class-name="action-column"
            >
              <template slot="header">
                <el-input 
                  v-model="tableSearch" 
                  size="small" 
                  placeholder="搜索属性名称"
                  prefix-icon="el-icon-search"
                  class="search-input"
                />
              </template>
              <template slot-scope="scope">
                <div class="action-buttons">
                  <el-button
                    size="small"
                    type="primary"
                    icon="el-icon-edit"
                    @click="updatePropertyBefore(scope.$index, scope.row)"
                    class="action-btn edit-btn"
                  >
                    修改
                  </el-button>
                  <el-button
                    size="small"
                    type="danger"
                    icon="el-icon-delete"
                    @click="handleDeletePropertyBefore(scope.$index, scope.row)"
                    class="action-btn delete-btn"
                  >
                    删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>
      <!-- 新增属性对话框 -->
      <el-dialog 
        title="新建属性" 
        :visible.sync="newPropertyVisible"
        width="500px"
        class="custom-dialog"
      >
        <el-form :model="propertyForm" label-width="120px" class="dialog-form">
          <el-form-item label="新属性名字">
            <el-input 
              placeholder="请输入新属性名字" 
              v-model="newPropertyName" 
              clearable 
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="newPropertyVisible = false">取 消</el-button>
          <el-button type="primary" @click="createNewProperty">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 修改属性对话框 -->
      <el-dialog 
        title="修改属性" 
        :visible.sync="updatePropertyVisible"
        width="500px"
        class="custom-dialog"
      >
        <el-form :model="updatePropertyForm" label-width="120px" class="dialog-form">
          <el-form-item label="旧属性名字">
            <el-input v-model="oldProperty.label" disabled />
          </el-form-item>
          <el-form-item label="新属性名字">
            <el-input 
              placeholder="请输入新属性名字" 
              v-model="updatePropertyName" 
              clearable 
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="updatePropertyVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateProperty">确 定</el-button>
        </div>
      </el-dialog>
      </el-col>

      <!-- 文件分类 -->
      <div v-if="fileTypeDataActive === true" class="content-section">
        <el-card class="content-card" shadow="always">
          <div class="card-header">
            <div class="header-info">
              <h2 class="section-title">文件分类</h2>
              <el-tag type="info" size="small" class="count-tag">
                共 {{ fileTypeData.length }} 个分类
              </el-tag>
            </div>
            <div class="header-actions">
              <el-button 
                type="primary" 
                icon="el-icon-plus"
                @click="fileTypeVisible = true"
                class="add-btn"
              >
                新增分类
              </el-button>
            </div>
          </div>

          <el-table 
            :max-height="tableHeight" 
            :data="fileTypeData" 
            class="data-table"
            stripe
          >
            <el-table-column
              prop="name"
              label="文件类型"
              min-width="60%"
              class-name="filetype-column"
            >
              <template slot-scope="{ row }">
                <div class="filetype-cell">
                  <i class="el-icon-folder"></i>
                  <span class="filetype-text">{{ row.name }}</span>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column 
              label="操作" 
              min-width="40%"
              class-name="action-column"
            >
              <template slot-scope="scope">
                <div class="action-buttons">
                  <el-button
                    size="small"
                    type="primary"
                    icon="el-icon-edit"
                    @click="updateFileTypeBefore(scope.row)"
                    class="action-btn edit-btn"
                  >
                    修改
                  </el-button>
                  <el-button
                    size="small"
                    type="danger"
                    icon="el-icon-delete"
                    @click="handleDeleteFileTypeBefore(scope.row)"
                    class="action-btn delete-btn"
                  >
                    删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>
    </div>
      <!-- 新增文件分类对话框 -->
      <el-dialog 
        title="新建分类" 
        :visible.sync="fileTypeVisible"
        width="500px"
        class="custom-dialog"
      >
        <el-form :model="fileTypeForm" label-width="120px" class="dialog-form">
          <el-form-item label="新分类名字">
            <el-input 
              placeholder="请输入新分类名字" 
              v-model="newFileType" 
              clearable 
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="fileTypeVisible = false">取 消</el-button>
          <el-button type="primary" @click="createNewFileType">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 修改文件分类对话框 -->
      <el-dialog 
        title="修改分类" 
        :visible.sync="updateFileTypeVisible"
        width="500px"
        class="custom-dialog"
      >
        <el-form :model="updateFileTypeForm" label-width="120px" class="dialog-form">
          <el-form-item label="旧分类名字">
            <el-input v-model="oldFileType.name" disabled />
          </el-form-item>
          <el-form-item label="新分类名字">
            <el-input 
              placeholder="请输入新分类名字" 
              v-model="updateFileTypeName" 
              clearable 
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="updateFileTypeVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateFileType">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    </div>
</template>

<script>
import { userApi, fileApi } from '@/api'
export default {
  name: 'UserManagement',
  data () {
    return {
      userData: [],
      userDataActive: false,
      propertyData: [],
      tableSearch: '',
      propertyDataActive: false,
      tableHeight: window.innerHeight * 0.7,
      newPropertyVisible: false,
      newPropertyName: '',
      updatePropertyVisible: false,
      updatePropertyName: '',
      oldProperty: {},
      updatePasswordVisible: false,
      oldPassword: '',
      newPassword: '',
      selectedUser: {},
      fileTypeDataActive: false,
      fileTypeData: [],
      newFileType: '',
      fileTypeVisible: false,
      updateFileTypeVisible: false,
      oldFileType: {},
      updateFileTypeName: ''
    }
  },
  mounted () {
    this.getProperty()
  },
  methods: {
    // 获取账号类型标签样式
    getAccountTypeTag (type) {
      const typeMap = {
        '管理员': 'danger',
        '普通用户': 'success',
        '访客': 'info'
      }
      return typeMap[type] || 'info'
    },

    handleSelect (key, keyPath) {
      // eslint-disable-next-line eqeqeq
      if (key == 1) {
        this.fileTypeDataActive = false
        this.propertyDataActive = false
        this.userDataActive = true
        this.getUsers()
      // eslint-disable-next-line eqeqeq
      } else if (key == 2) {
        this.userDataActive = false
        this.fileTypeDataActive = false
        this.propertyDataActive = true
        this.getProperty()
      // eslint-disable-next-line eqeqeq
      } else if (key == 3) {
        this.userDataActive = false
        this.fileTypeDataActive = true
        this.propertyDataActive = false
        this.getFileType()
      }
    },
    async createNewProperty () {
      try {
        await userApi.addProperty({
          name: this.newPropertyName
        })
        this.$message.success('新增属性成功')
        this.getProperty()
        this.newPropertyVisible = false
        this.newPropertyName = ''
      } catch (error) {
        console.error('新增属性失败:', error)
        this.$message.error('新增属性失败')
      }
    },
    async getProperty () {
      try {
        const response = await userApi.getAllProperties()
        this.propertyData = response
      } catch (error) {
        console.error('获取属性失败:', error)
        this.$message.error('获取属性失败')
      }
    },
    updatePropertyBefore (index, row) {
      this.oldProperty = row
      this.updatePropertyVisible = true
    },
    async updateProperty () {
      try {
        await userApi.updateProperty({
          oldId: this.oldProperty.value,
          newName: this.updatePropertyName
        })
        this.$message.success('修改属性成功')
        this.getProperty()
        this.updatePropertyVisible = false
      } catch (error) {
        console.error('修改属性失败:', error)
        this.$message.error('修改属性失败')
      }
    },
    handleDeletePropertyBefore (index, row) {
      this.$confirm('是否删除属性     ' + row.label, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleDeleteProperty(row.value)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    async handleDeleteProperty (id) {
      try {
        await userApi.deleteProperty(id)
        this.$message.success('删除成功')
        this.getProperty()
      } catch (error) {
        console.error('删除属性失败:', error)
        this.$message.error('删除属性失败')
      }
    },
    async logout () {
      try {
        await userApi.logout()
        localStorage.clear()
        this.$router.push('/login')
      } catch (error) {
        console.error('退出失败:', error)
        localStorage.clear()
        this.$message.error('退出失败')
      }
    },
    async getUsers () {
      try {
        const response = await userApi.getAllUsers()
        this.userData = response
      } catch (error) {
        console.error('获取用户列表失败:', error)
        this.$message.error('获取用户列表失败')
      }
    },
    beforeUpdatePassword (index, row) {
      this.selectedUser = row
      this.updatePasswordVisible = true
    },
    async updatePassword () {
      let data = { id: this.selectedUser.id, oldPassword: this.oldPassword, newPassword: this.newPassword }
      try {
        await userApi.updatePassword(data)
        this.$message.success('修改成功')
        this.updatePasswordVisible = false
      } catch (error) {
        console.error('修改密码失败:', error)
        this.$message.error('修改密码失败')
      }
    },
    async getFileType () {
      try {
        const response = await fileApi.getFileTypes()
        this.fileTypeData = response
      } catch (error) {
        console.error('获取文件类型失败:', error)
        this.$message.error('获取文件类型失败')
      }
    },
    updateFileTypeBefore (row) {
      this.oldFileType = row
      this.updateFileTypeVisible = true
    },
    handleDeleteFileTypeBefore (row) {
      this.$confirm('是否删除分类     ' + row.name, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleDeleteFileType(row)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    async handleDeleteFileType (row) {
      try {
        await fileApi.deleteFileType(row.id)
        this.getFileType()
      } catch (error) {
        console.error('删除文件类型失败:', error)
        this.$message.error('删除文件类型失败')
      }
    },
    async createNewFileType () {
      try {
        await fileApi.addFileType(this.newFileType)
        this.getFileType()
        this.fileTypeVisible = false
      } catch (error) {
        console.error('创建文件类型失败:', error)
        this.$message.error('创建文件类型失败')
      }
    },
    async updateFileType () {
      try {
        await fileApi.updateFileTypeName({ oldId: this.oldFileType.id, newName: this.updateFileTypeName })
        this.$message.success('修改属性成功')
        this.getFileType()
        this.updateFileTypeVisible = false
      } catch (error) {
        console.error('修改文件类型失败:', error)
        this.$message.error('修改文件类型失败')
      }
    }
  }
}
</script>

<style scoped>
.user-management {
  display: flex;
  min-height: 100vh;
  background-color: #f5f7fa;
  gap: 20px;
  padding: 20px;
}

/* 左侧导航栏 */
.sidebar {
  width: 280px;
  flex-shrink: 0;
}

.nav-card {
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.nav-header {
  text-align: center;
  padding: 20px 0;
  border-bottom: 1px solid #EBEEF5;
  margin-bottom: 20px;
}

.nav-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 8px 0;
}

.nav-subtitle {
  font-size: 14px;
  color: #909399;
  margin: 0;
}

.nav-menu {
  border: none;
}

.nav-menu .el-menu-item {
  height: 50px;
  line-height: 50px;
  margin: 8px 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.nav-menu .el-menu-item:hover {
  background-color: #ECF5FF;
  color: #409EFF;
}

.nav-menu .el-menu-item.is-active {
  background-color: #409EFF;
  color: white;
}

.nav-menu .el-menu-item i {
  margin-right: 12px;
  font-size: 16px;
}

/* 主要内容区域 */
.main-content {
  flex: 1;
  min-width: 0;
}

.content-section {
  width: 100%;
}

.content-card {
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

/* 卡片头部 */
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  border-bottom: 1px solid #EBEEF5;
  margin-bottom: 20px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

.count-tag {
  background-color: #F4F4F5;
  color: #909399;
  border: none;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.add-btn, .logout-btn {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.add-btn:hover, .logout-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 表格样式 */
.data-table {
  border-radius: 8px;
  overflow: hidden;
}

.username-cell, .property-cell, .filetype-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.username-cell i, .property-cell i, .filetype-cell i {
  color: #409EFF;
  font-size: 16px;
}

.username-text, .property-text, .filetype-text {
  font-weight: 500;
  color: #303133;
}

.type-tag {
  border-radius: 4px;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.action-btn {
  border-radius: 6px;
  font-size: 12px;
  padding: 6px 12px;
  transition: all 0.3s ease;
}

.edit-btn {
  background-color: #ECF5FF;
  color: #409EFF;
  border-color: #B3D8FF;
}

.edit-btn:hover {
  background-color: #409EFF;
  color: white;
}

.delete-btn {
  background-color: #FEF0F0;
  color: #F56C6C;
  border-color: #FBC4C4;
}

.delete-btn:hover {
  background-color: #F56C6C;
  color: white;
}

/* 搜索输入框 */
.search-input {
  width: 200px;
}

/* 对话框样式 */
.custom-dialog .el-dialog {
  border-radius: 12px;
}

.custom-dialog .el-dialog__header {
  background: linear-gradient(135deg, #409EFF 0%, #337ECC 100%);
  color: white;
  border-radius: 12px 12px 0 0;
  padding: 20px;
}

.custom-dialog .el-dialog__title {
  color: white;
  font-weight: 600;
}

.custom-dialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
}

.custom-dialog .el-dialog__body {
  padding: 30px;
}

.dialog-form .el-form-item {
  margin-bottom: 20px;
}

.dialog-form .el-form-item__label {
  font-weight: 500;
  color: #606266;
}

.dialog-footer {
  text-align: right;
  padding-top: 20px;
  border-top: 1px solid #EBEEF5;
}

.dialog-footer .el-button {
  border-radius: 6px;
  padding: 10px 20px;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .user-management {
    flex-direction: column;
    gap: 15px;
  }
  
  .sidebar {
    width: 100%;
  }
  
  .nav-menu {
    display: flex;
    justify-content: center;
  }
  
  .nav-menu .el-menu-item {
    margin: 4px 8px;
  }
}

@media (max-width: 768px) {
  .user-management {
    padding: 10px;
  }
  
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .header-actions {
    width: 100%;
    justify-content: flex-end;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
  
  .action-btn {
    width: 100%;
    font-size: 11px;
    padding: 4px 8px;
  }
  
  .search-input {
    width: 100%;
  }
  
  .custom-dialog .el-dialog {
    width: 95% !important;
    margin: 0 auto;
  }
}

@media (max-width: 480px) {
  .nav-menu {
    flex-direction: column;
  }
  
  .nav-menu .el-menu-item {
    margin: 2px 0;
  }
  
  .section-title {
    font-size: 16px;
  }
  
  .count-tag {
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/UserManagement.vue